import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const InstagramIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12.085 8.643a3.397 3.397 0 0 0-3.386 3.385 3.397 3.397 0 0 0 3.386 3.386c1.861 0 3.37-1.525 3.37-3.386 0-1.861-1.525-3.385-3.37-3.385Zm0 5.968a2.582 2.582 0 0 1-2.583-2.583 2.582 2.582 0 0 1 2.583-2.583 2.578 2.578 0 0 1 2.567 2.583 2.578 2.578 0 0 1-2.567 2.583ZM15.855 6.733c-.353 0-.674.129-.915.37-.24.24-.368.56-.368.914 0 .353.128.674.369.914.24.241.561.37.914.37s.674-.129.915-.37a1.36 1.36 0 0 0 .385-.898v-.016c0-.337-.145-.658-.37-.883a1.274 1.274 0 0 0-.93-.4Zm.337 1.62a.516.516 0 0 1-.69 0 .462.462 0 0 1-.144-.336c0-.129.048-.257.144-.337a.462.462 0 0 1 .337-.145.498.498 0 0 1 .498.466.448.448 0 0 1-.145.353Z"
    />
    <Path
      fill="#000"
      d="M14.892 5.113H9.261a4.088 4.088 0 0 0-4.092 4.091v5.648a4.088 4.088 0 0 0 4.092 4.092h5.647A4.088 4.088 0 0 0 19 14.852V9.204a4.112 4.112 0 0 0-4.108-4.091Zm3.29 9.739a3.294 3.294 0 0 1-3.29 3.29H9.261a3.294 3.294 0 0 1-3.29-3.29V9.204a3.294 3.294 0 0 1 3.29-3.29h5.647a3.294 3.294 0 0 1 3.29 3.29v5.648h-.016Z"
    />
  </Svg>
)
export default InstagramIcon
